import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { RootState } from '../../global';
import { fetchConfigFees } from './app-api';

export const useFetchConfiguration = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchConfigFees());
  }, [dispatch]);
};

export const useSelectConfiguration = () =>
  useSelector((state: RootState) => state.configuration);
